export default __webpack_public_path__ + "static/media/enclaves.8c401f2e.webm";